import Hero from "./components/Hero";
import LocationMap from "./components/LocationMap";

export default function Location() {
  return (
    <div className="min-h-screen">
      <Hero />
      <LocationMap />
    </div>
  );
}
